module.exports = __webpack_public_path__ + "images/f9fe7499ca1978e8255f5a94e1e512bf.svg";